export const BuildersClubNorth = "BCN";
export const BuildPerks = "BuildPerks";
